/* STILL 18.8 · smoother scrolling. Nothing on the page looks or moves differently.
   Loaded first, in <head> (snippets/still-perf.liquid, part 'head'), before every other script of the page.

   Why: in this theme a change on the <html> element itself makes the browser restyle the whole page,
   about 2 000 elements (a class: because of the theme's custom scrollbar rule in base.css; an inline
   custom property: because every element inherits it). On a phone that is a 50–200 ms freeze, and it
   happened while scrolling:
     · when the sticky buy bar appears or goes away (the STILL script puts .nx-sbar-on on <html>),
       when the scratch card opens (.nx-sc-open), when the first photo is ready (.nx-ph-ready);
     · every time the phone's address bar slides in or out: the Releasit order form writes its --vh
       on <html> on every resize, though only its own window uses it;
     · at the first scroll: the header's height (--nx-top) was written then, once or twice.
   What this file does, without changing what any of them mean:
     1. .nx-sbar-on, .nx-sc-open and .nx-ph-ready go on <body> instead of <html>. No stylesheet uses
        them (html.classList.contains() still answers for them). .nx-zoom-open stays on <html>: it
        stops the page from scrolling under the zoomed photo.
     2. Releasit's --vh: only its order form uses it, and the form is a <dialog>. While no dialog is
        open the newest value waits here and is written just before a dialog opens; while one is open
        it is written at once, as before.
     3. A custom property written on <html> with the value it already has is not written again (a
        write that changes nothing would still restyle the page in some browsers).
     4. --nx-top: snippets/still-perf.liquid (part 'top') writes it right after the header is on the
        page, while the page is still short. Here it is measured again once the page and its fonts
        have loaded, the way the STILL script measures it, so the STILL script's own write later
        finds the same value and changes nothing. The header sticks one pixel above the screen
        (the theme's way to notice that it sticks), so its bottom edge is 60 px at the very top of
        the page and 59 px everywhere else: the STILL script wrote 59 at the first scroll and 60
        again at the top, each time restyling the page. The value used everywhere is the one for
        the stuck header (the one the sticky STILL parts line up with); a write only one pixel
        larger than it is not made.
   If a browser lacks something used here, that part is skipped and the page works as before. */
(function () {
  'use strict';
  if (window.__nxPerf) return;
  window.__nxPerf = true;
  var html = document.documentElement;

  /* ---------- 1 · classes that nothing styles: on <body>, not on <html> ---------- */
  var MOVE = { 'nx-sbar-on': 1, 'nx-sc-open': 1, 'nx-ph-ready': 1 };
  try {
    var real = html.classList;
    var bodyList = function () { return document.body ? document.body.classList : null; };
    var proxy = new Proxy(real, {
      get: function (t, k) {
        if (k === 'add' || k === 'remove') {
          return function () {
            var keep = [], move = [], b = bodyList();
            for (var i = 0; i < arguments.length; i++) (MOVE[arguments[i]] && b ? move : keep).push(arguments[i]);
            if (keep.length) t[k].apply(t, keep);
            if (move.length) {
              b[k].apply(b, move);
              if (k === 'remove') move.forEach(function (c) { if (t.contains(c)) t.remove(c); });   // put on <html> before <body> existed
            }
          };
        }
        if (k === 'toggle') {
          return function (c, force) {
            var b = MOVE[c] && bodyList();
            if (!b) return arguments.length > 1 ? t.toggle(c, force) : t.toggle(c);
            if (t.contains(c)) t.remove(c);
            return arguments.length > 1 ? b.toggle(c, force) : b.toggle(c);
          };
        }
        if (k === 'contains') {
          return function (c) { var b = MOVE[c] && bodyList(); return t.contains(c) || !!(b && b.contains(c)); };
        }
        var v = Reflect.get(t, k, t);
        return typeof v === 'function' ? v.bind(t) : v;
      },
      set: function (t, k, v) { t[k] = v; return true; }
    });
    Object.defineProperty(html, 'classList', {
      configurable: true,
      get: function () { return proxy; },
      set: function (v) { real.value = v; }
    });
  } catch (e) { /* no Proxy: the classes stay on <html>, as before */ }

  /* ---------- 2 + 3 · custom properties on <html> ---------- */
  var st = html.style, set0 = st.setProperty, pendVh = null;
  function dialogOpen() { try { return !!document.querySelector('dialog[open]'); } catch (e) { return true; } }
  function flushVh() {
    if (pendVh === null) return;
    var v = pendVh; pendVh = null;
    if (st.getPropertyValue('--vh') !== v) set0.call(st, '--vh', v);
  }
  try {
    st.setProperty = function (name, value, prio) {
      var v = value == null ? '' : String(value);
      if (name === '--vh' && !prio) {
        if (!dialogOpen()) { pendVh = v; return; }
        pendVh = null;
      }
      if (name === '--nx-top') {
        var cur = parseFloat(st.getPropertyValue('--nx-top')), nv = parseFloat(v);
        if (cur > 0 && nv > cur && nv - cur <= 1) return;      // the header before it sticks: keep the stuck value
      }
      if (typeof name === 'string' && name.lastIndexOf('--', 0) === 0 &&
          st.getPropertyValue(name) === v && st.getPropertyPriority(name) === (prio || '')) return;
      return set0.apply(st, arguments);
    };
    ['showModal', 'show'].forEach(function (m) {
      var D = window.HTMLDialogElement && HTMLDialogElement.prototype, f = D && D[m];
      if (typeof f !== 'function') return;
      D[m] = function () { flushVh(); return f.apply(this, arguments); };
    });
    document.addEventListener('nocta:cod:open', flushVh);
  } catch (e) { /* as before */ }

  /* ---------- 4 · --nx-top, measured the way the STILL script measures it ---------- */
  var HDR = '[data-nx-header],.shopify-section-header-sticky,.section-header,sticky-header,#shopify-section-header,.site-header,header';
  function headerInset() {
    var list = document.querySelectorAll(HDR), hdr = null;
    for (var i = 0; i < list.length && i < 14; i++) {
      if (list[i].closest('.nx')) continue;
      var pos = getComputedStyle(list[i]).position;
      if (pos === 'sticky' || pos === 'fixed') { hdr = list[i]; break; }
    }
    var p = document.createElement('div');
    p.style.cssText = 'position:fixed;top:0;left:0;width:0;height:0;visibility:hidden;padding-top:env(safe-area-inset-top,0px)';
    document.body.appendChild(p);
    var t = parseFloat(getComputedStyle(p).paddingTop) || 0;
    p.remove();
    if (hdr) {
      var r = hdr.getBoundingClientRect(), b = r.bottom, cs = getComputedStyle(hdr), tt = parseFloat(cs.top);
      if (cs.position === 'sticky' && isFinite(tt)) b = Math.min(b, tt + r.height);   // its bottom edge once it sticks
      if (r.height > 0 && b > 0 && r.top < innerHeight * 0.25) t = Math.max(t, b);
    }
    return Math.round(Math.min(Math.max(t, 0), innerHeight * 0.3));
  }
  function topNow() {
    try {
      if (!document.body || !document.querySelector('[data-nocta]')) return;
      var t = headerInset(), cur = st.getPropertyValue('--nx-top');
      if (t > 0 && cur !== t + 'px') set0.call(st, '--nx-top', t + 'px');
    } catch (e) { /* the STILL script writes it itself, as before */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', topNow);
  else topNow();
  window.addEventListener('load', topNow);
  try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(topNow); } catch (e) { /* old browser */ }
})();
